export default class MultipleSelectionTreeControl {
    constructor(resourcesHandler, classId, menuContainer) {
        this.resourcesHandler = resourcesHandler;
        this.classId = classId;
        this.menuContainer = menuContainer;
    }

    init() {
        if ($(this.menuContainer).find(".toolbar-selection").length == 0) {
            $(this.menuContainer).append('<div class="map-toolbar toolbar-selection shadow-4" style="left: 3.7rem; right: unset; width: fit-content;"></div>');
        }

        if ($(this.menuContainer).find(".map-toolbar-selected-items").length == 0) {
            $(this.menuContainer).find(".toolbar-selection").append(`<ul class="map-toolbar-selected-items" style="display: none;">
                <li class="toolbar-selected-items-title">` + this.resourcesHandler.get('SelectTargetElement') + `</li>
                <li class="toolbar-selected-items-wrapper"></li>
            </ul>`);
        }
    }
}
